import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import EventCalendar from "./Components/EventCalendar";
import EventLayout from "./Components/EventLayout";
import DashboardHome from "./Components/Dashboard/DashboardHome";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<EventCalendar />} />
        <Route path="/events/:event_slug/*" element={<EventLayout />}/>
        <Route path="/dashboard/*" element={<DashboardHome />} />
      </Routes>
    </div>
  );
}

export default App;
